<!-- 创建时间2023/06/20 10:35:07 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：app缓存 -->
<template>
  <div>
    <yxt-tooltip
      :disabled="!info.serverGroupId"
      effect="dark"
      :content="$t('pc_kng_courseware_lbl_cache_not_allowed' /*为保证资源安全，私有云课件不允许学员缓存哦～*/)"
      placement="bottom-start"
    >
      <yxt-checkbox v-model="allowDownload_" :true-label="1" :false-label="0" :disabled="disabled">
        {{ $t('pc_kng_lbl_allow_cache'/** 允许缓存 */) }} 
        <span v-if="allowDownload_">
          {{ $t('pc_kng_msg_view_without_traffic'/**（缓存后，学员在App内无需流量即可查看，但不能分享、转发）*/) }}
        </span>
      </yxt-checkbox>
    </yxt-tooltip>
    <div v-if="allowDownload_">
      <yxt-radio-group class="ml24" v-model="permissionType" direction="row" :disabled="disabled">
        <yxt-radio :label="0">{{ $t('pc_kng_lbl_classification_app_cache'/** 跟随分类中的“App缓存课件”权限 */) }}</yxt-radio>
        <yxt-radio :label="1">{{ $t('pc_kng_upload_lbl_cache_allow'/** 单独设置允许缓存 */) }}</yxt-radio>
      </yxt-radio-group>
      <auth-selector
        v-if="permissionType === 1"
        class="mt10 ml24"
        :permissions="permissions"
        :disabled="disabled"
        dataPermissionCode="kjgl_Courseware_cache_selection_range"
        @update="update"
      />
    </div>
  </div>
</template>

<script>
import authSelector from './auth-selector.vue';
export default {
  name: 'form-app-cache',
  inject: ['getInfo'],
  components: {
    authSelector
  },
  props: {
    allowDownload: {
      // 是否允许缓存
      type: Number,
      default: undefined
    },
    value: {
      // 权限类型 跟随目录 or 单独设置
      type: Number,
      default: 0
    },
    permissions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    allowDownload_: {
      get() {
        return this.allowDownload;
      },
      set(val) {
        this.$emit('update:allowDownload', val);
      }
    },
    permissionType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    info() {
      return this.getInfo();
    }
  },
  created() {
    if (this.allowDownload === undefined) {
      this.allowDownload_ = !this.info.serverGroupId ? 1 : 0;
    }
  },
  methods: {
    update(val) {
      this.$emit('update:permissions', val);
    }
  }
};
</script>